<template>
    <div class="animated fadeIn equipmentList bgV2 column-setting-container">
      <div class="boxShadow heig-frame-tab clear-border-top mb-20 mt-25">
        <!--Box 1: Table Preview-->
        <div class="boxShadow  bg-white mb-3 pl-0 pr-0">
          <div class="pl-30">
            <div class="title previewTitle">Preview</div>
          </div>

          <b-col md="12" class="pl-0 pr-0">
              <!-- <vue-scrollbar class="fixed-scrollbar tableList"> -->
                <b-table :fields="demoFields" :responsive="true"  :items="demoItems" class="table-filter" fixed>
                  <template slot="HEAD_actions" slot-scope="foo">
                    <b-form-checkbox class="uniform" @input="toggleSelected" v-model="allSelected"></b-form-checkbox>
                  </template>
                  <template slot="actions" slot-scope="row">
                    <b-form-checkbox :value="row.item.actions" v-model="selected"></b-form-checkbox>
                  </template>
                </b-table>
              <!-- </vue-scrollbar> -->
          </b-col>
        </div>
            <div class="bgMain">
                <b-row>
                  <b-col md="3">

                      <div class="widgetV2 heig-frame-child">
                          <div class="pl-10">
                              <div class="title previewTitle">Tables</div>
                          </div>
                          <div class="contenAbsolute">
                              <div class="tree-view-properties">
                                  <tree ref="treeViewModules" @node:selected="changeTableName" :data="TableItems.data" class="tree-view-properties"></tree>
                              </div>
                          </div>
                      </div>
                  </b-col>
                  <b-col md="7" class="pr-0 pl-0">
                    <div style="border-right-color: rgb(255, 255, 255);" class="widgetV2 heig-frame-child">
                      <div class="widget-header">
                          <div class="title" style="opacity: 1">Columns</div>
                          <gofix-button :disabled="!$checkRole($accessModule.web_column_setting, 'update')" class="mr-3 pull-right" label="Save" @click="saveColumnSetting"></gofix-button>
                          <gofix-button class="mr-3 pull-right" label="Preview" @click="preview" outline></gofix-button>
                      </div>
                      <draggable
                        :list="columnSettings"
                        class="list-group"
                        ghost-class="ghost"
                        @start="dragging = true"
                        @end="dragEnd"
                      >
                      
                      <div class="list-item" v-for="element in columnSettings" :key="element.key">
                        <div v-if="element.key != 'actions'" class="column-setting odd" v-bind:class="{'cs-enable': element.isActive, 'cs-disable': !element.isActive, 'clicked': clicked == element.key}" :style="{width: elementWidth}">
                          <Column :onClick="onClick" :resizable="element.isActive" :item="element" :field_name="element.label" @changeWidth="changeWidth(...arguments, element)" :w="parseInt(element.width)" :h="50" :parent="false" :max-width="maxWidth"></Column>
                          <div v-if="element.sequence != 0" @click="element.isActive = !element.isActive" v-bind:class="{'eye_on': element.isActive, 'eye_off': !element.isActive}"></div>
                        </div>
                      </div>
                      </draggable>
                    </div>
                  </b-col>

                  <b-col md="2" class="pl-0">
                    <div class="widgetV2 heig-frame-child">
                      <div class="pl-0">
                          <div class="title">Detail</div>
                      </div>
                      <div class="formV2 pl-20 pr-20 noOverflow bg-white" style="border:none">
                        <b-row class="mt-10 content">
                          <b-col md="12">
                              <gofix-form-input label="Name" v-model="selectedItem.label"></gofix-form-input>
                              <!-- v-model="selectedItem.width" -->
                              <gofix-form-input-number label="Width" :thousandsSeparatorSymbol="''" :integerLimit="4" :value="selectedItem.width" @input="checkMaxWidth"></gofix-form-input-number>
                              <gofix-form-input label="FilterType" v-model="selectedItem.filter.type" disabled></gofix-form-input>
                              <gofix-form-dropdown
                                      label="Alignment"
                                      v-model="selectedItem.alignment"
                                      :options="['left', 'center', 'right']">
                              </gofix-form-dropdown>
                              <gofix-form-dropdown
                                      label="Default Sorting"
                                      v-model="selectedItem.default_sorting"
                                      :options="['off', 'asc', 'desc']">
                              </gofix-form-dropdown>
                          </b-col>


                        </b-row>
                      </div>
                    </div>
                  </b-col>
                </b-row>
            </div>
      </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import draggable from 'vuedraggable'
    import LiquorTree from 'liquor-tree';
    const Column = () => import('./Column')
    import { floatLabel } from '@/_floatLableClass.js'
    export default {
        name: 'Role',
        data() {
          return {
            width: null,
            maxWidth: 1000,
            elementWidth: '100%',
            tableName: 'client-contract-listing',
            demoItems: [],
            demoFields: [],
            collapsePreview: true,
            clicked: null,
            columnSettings: [

            ],
            dragging: false,
            pages:{
              limit: -1,
              page: 1,
              filter: {},
              group_session: 1,
            },
            roleModules: [],
            nodeID: null,
            selectedItem: {
              key: null,
              label: null,
              width: null,
              default_sorting: 'off',
              alignment: null,
              filter: {
                type: null
              }
            },
            allSelected: false,
            selected: [],
          }
        },
        components: {
            [LiquorTree.name]: LiquorTree,
            Column,
            draggable
        },
        created() {
            this.$store.dispatch("AuthController/getTableItems",this.pages)
                .then(data => {
                    // this.roleModules = data.active.role_modules;
                    // this.nodeID = data.active.id;
                    // //this.$set(this.$refs.treeViewModules, 'model', data.items);
                    this.$refs.treeViewModules.tree.setModel(data.items);
                });
            // get first table setting
            this.getDefaultColumnSettings("client-contract-listing");
        },
        watch: {
          selected: function(val) {
            if(this.demoItems.length > val.length) {
              this.allSelected = false
              return
            }
            if(val.length > 0 && this.demoItems.length == val.length) {
              this.allSelected = true
            }
          },
          "selectedItem.width": function(val) {
            this.checkAddWidth()
          },
            ClientContractID: function(val){
                let tableActive = this.$refs.treeViewModules.tree.find({state: {selected: true}});
                if(tableActive && tableActive[0] && tableActive[0].data.has_contract){
                    if(!val){
                        this.$bvToast.toast("Please select a client contract to show settings", {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        });
                        this.columnSettings = [];
                    }else{
                        this.getDefaultColumnSettings(this.tableName,val.id);
                    }
                }
            }
        },
        computed: {
            ...mapGetters({
                TableItems: 'AuthController/TableItems',
                Loadings: 'RoleController/Loadings',
                ClientContractID: 'ContractController/ClientContractID',
            })
        },
        methods: {
          checkMaxWidth(val) {
            if(!val) {
              this.selectedItem.width = 0;
              return;
            }
            if(parseInt(val) > this.maxWidth) {
              this.selectedItem.width = 1000;
              this.$bvToast.toast('Maximum width is 1000px', {
                  title: `Notification`,
                  autoHideDelay: 3000,
                  variant: 'warning',
                  solid: true
              })
              return
            }
            this.selectedItem.width = val
          },
          checkAddWidth() {
            this.elementWidth ='100%'
            let elWidth = this.$el.querySelector('.list-group').clientWidth-200;
            this.columnSettings.forEach(item => {
              if((item.width) > elWidth) {
                this.elementWidth ='1200px'
                return;
              }
            })
          },
          changeWidth(width, element) {
            element.width = width
            this.checkAddWidth();
          },
          changeTableName: function(item){
            let contract_id = this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : null;
            this.selected = [];
            this.allSelected = false;
            this.collapsePreview = true;
            this.demoItems = [];
            this.demoFields = [];
            this.setDetail({
              key: null,
              label: null,
              width: null,
              default_sorting: 'off',
              alignment: null,
              filter: {
                type: null
              }
            });
            this.tableName = item.data.key.replace("&", "and");
            if(item.data.has_contract){
                //contract_id = this.ClientContractID
                if(!this.ClientContractID){
                    this.$bvToast.toast("Please select a client contract", {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'danger',
                        solid: true
                    });
                    this.columnSettings = [];
                    return;
                }
                contract_id = this.ClientContractID.id;
            }
            this.getDefaultColumnSettings(this.tableName,contract_id);
          },
          onClick: function(item){
            this.clicked = item.key;
            this.setDetail(item);
          },
          toggleSelected(val) {
            if (this.allSelected) {
              this.selected = [];
              for (let i in this.demoItems) {
                this.selected.push(this.demoItems[i].actions)
              }
              return
            }
            if(!this.allSelected && this.demoItems.length == this.selected.length) {
              this.selected = []
            }
          },
          dragEnd: function(){
            this.dragging = false
            this.columnSettings.forEach((item, index) => {
              item.sequence = index + 1;
            })
          },
          setDetail: function(item){
            this.width = item.width
            this.selectedItem = item;
          },
          getDefaultColumnSettings: function(table_name,contract_id = null){
            this.columnSettings = [];
            this.$store.dispatch('AuthController/getNewColumnSettingsTableUser', { user_id: 0, table_name: table_name,contract_id:contract_id }).then(response => {
                this.columnSettings = response.data.data.settings.fields
                this.checkAddWidth();
            }).catch(error =>{})
          },
          saveColumnSetting: function(){
            // validate
            let count  = 0;
            let contract_id =  null;

            this.columnSettings.forEach((item, index) => {
              if(item.default_sorting != 'off'){
                count = count + 1;
              }
              item.thStyle = "width:" + item.width + "px";
              if(item.alignment){
                item.thClass = 'text-' + item.alignment
                item.tdClass = 'text-' + item.alignment
              }
            })
            if(count > 1){
              return this.$bvToast.toast('Cannot set default sorting for multiple columns!', {
                  title: `Notification`,
                  autoHideDelay: 3000,
                  variant: 'danger',
                  solid: true
              })
            }

              //Get table setting selected
              let tableActive = this.$refs.treeViewModules.tree.find({state: {selected: true}});
              if(tableActive && tableActive[0] && tableActive[0].data.has_contract){
                  contract_id = this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : null;
              }

            this.$store.dispatch('AuthController/updateColumnSettingsUser', {
                    user_id: 0,
                    table_name: this.tableName,
                    contract_id: contract_id,
                    settings: JSON.stringify({fields: this.columnSettings})
                })
            .then(response => {
              this.$bvToast.toast( this.$notificationV2('editing', 'column_setting'), {
                  title: `Notification`,
                  autoHideDelay: 3000,
                  variant: 'success',
                  solid: true
              })
            })
            .catch(err => { this.$refs['modal-Columns'].hide(); })
          },
          preview: function(){
            this.collapsePreview = !this.collapsePreview

            if(this.collapsePreview){
              this.demoItems = [];
              this.demoFields = [];
              return;
            }
            this.demoItems = [];
            this.demoFields = [];
            let tmpShow =  this.columnSettings.filter(item => item.isActive == 1).sort((a,b) => a.sequence > b.sequence)
            tmpShow.forEach((item, index) => {
              item.thStyle = "width:" + item.width + "px";
              if(item.alignment){
                item.thClass = 'text-' + item.alignment
                item.tdClass = 'text-' + item.alignment
              }
            })

            // let checbox =  {
            //   key: 'actions',
            //   label: '',
            //   thClass: 'checkbox-column text-center',
            //   tdClass: 'checkbox-column text-center',
            //   width: 50,
            //   thStyle: "width:50px",
            // }
            let fields = JSON.parse(JSON.stringify(tmpShow));
            // tmpShow.unshift(checbox)
            this.demoFields = tmpShow ;
            let i =0;
            for(i=0; i<=2; i++){
              let tmpData = {}
              fields.forEach((obj) => {
                tmpData[obj.key] = obj.key + "_" + i;
              })
              this.demoItems.push(tmpData);
              tmpData = {}
            }
          }

        },
        mounted: function() {
          floatLabel()
        },
        updated: async function() {
          floatLabel()
        },

    }
</script>

